import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import MuiSvgIcon from '@material-ui/core/SvgIcon';
import { useStyles, logoDark, FooterLogic } from './footer.module';

const Footer = () => {
  const classes = useStyles();
  const { translator } = FooterLogic();

  return (
    <div>
      <div className={classes.gridContainer}>
        <div className={classes.left}>
          <div className={classes.content}>
            <Typography className={classes.title}>
              {' '}
              {translator('footer_title')}
            </Typography>
            <img
              className={classes.logoEgreenDark}
              src={logoDark}
              alt="eGreen Logo"
            />
          </div>
        </div>
        <div>
          <Typography className={classes.subtitle}>
            hello@egreen.com{' '}
          </Typography>
          <div className={classes.start}>
            <div className={classes.gridItemStart}>
              <div>
                <Link className={classes.customLink} to="/egreen">
                  <Typography className={classes.fontLink}>
                    {translator('footer_abouts')}
                  </Typography>
                </Link>
              </div>
              <div>
                <Link className={classes.customLink} to="/CarbonManagement">
                  <Typography className={classes.fontLink}>
                    {translator('footer_carbon')}
                  </Typography>
                </Link>
                <Link className={classes.customLink} to="/coins">
                  <Typography className={classes.fontLink}>
                    {' '}
                    {translator('footer_investment')}
                  </Typography>{' '}
                </Link>
                <Link className={classes.customLink} to="/projects">
                  <Typography className={classes.fontLink}>
                    {' '}
                    {translator('footer_projects')}
                  </Typography>
                </Link>
                <Link className={classes.customLink} to="/blog">
                  <Typography className={classes.fontLink}>
                    {translator('footer_news')}
                  </Typography>
                </Link>
              </div>
              <div>
                <Link className={classes.customLink} to="/">
                  <Typography className={classes.fontLink}>
                    {translator('footer_map')}
                  </Typography>
                </Link>
                <Link className={classes.customLink} to="/questions">
                  <Typography className={classes.fontLink}>
                    {translator('footer_faqs')}
                  </Typography>
                </Link>
                <Link className={classes.customLink} to="/">
                  <Typography className={classes.fontLink}>
                    {translator('footer_conditions')}
                  </Typography>
                </Link>
              </div>
              <div></div>
            </div>
          </div>

          <div className={classes.end}>
            <div className={classes.gridItemEnd}>
              <div>
                <Link className={classes.customLink} to="/">
                  <Typography className={classes.fontLinkLigth}>
                    {translator('footer_privacy')}
                  </Typography>
                </Link>
              </div>
              <div>
                <Link className={classes.customLink} to="/">
                  <Typography className={classes.fontLinkLigth}>
                    {translator('footer_service')}
                  </Typography>
                </Link>
              </div>
              <div className={classes.network}>
                <div>
                  <a
                    href={
                      'https://www.facebook.com/profile.php?id=100063829637344'
                    }
                    target="_blank"
                  >
                    <MuiSvgIcon
                      component="svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className={`${classes.icon} MuiSvgIcon-root makeStyles-facebook-29`}
                    >
                      <path
                        fill="currentColor"
                        d="M12 0C5.373 0 0 5.373 0 12c0 6.225 4.55 11.373 10.5 12.358V15.373H7.469V12h3.031V9.453c0-3.014 1.787-4.676 4.539-4.676 1.313 0 2.441.098 2.77.141v3.14l-1.898.001c-1.493 0-1.783.711-1.783 1.745V12h3.563l-.46 3.373H12v8.029c5.949-.985 10.5-6.133 10.5-12.358C24 5.373 18.627 0 12 0"
                      />
                    </MuiSvgIcon>
                  </a>
                </div>
                <div>
                  <a
                    href={'https://www.instagram.com/egreen.finance/'}
                    target="_blank"
                  >
                    <InstagramIcon className={classes.icon} />
                  </a>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
